import { withStyles } from "@material-ui/styles";
import React from "react";
import { withRouter } from "react-router-dom";
import deleteAccFlow from "../../../assets/images/deleteAccFlow.png";
import { compose } from "recompose";
import { Typography } from "@material-ui/core";

function DeleteAccMap({ classes }) {
  return (
    <>
      <div className={classes.container}>
        <img
          src={deleteAccFlow}
          alt="Delete Account Flow"
          className={classes.responsiveImage}
        />
      </div>
      <div style={{ padding: "20px", display: "flex", justifyContent: "center" }}>
        <Typography variant="h6" sx={{ marginBottom: "8px" }}>
          If you already have an account, click below to go to the login page:{" "}
          <a
            href="https://events.necessarydevil.com/login"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "underline",
              color: "#1976d2",
            }}
          >
            Go to Login
          </a>
        </Typography>
      </div>
    </>
  );
}

const styles = (theme) => ({
  container: {
    width: "100%",
    textAlign: "center", // center the image horizontally if not full width
  },
  responsiveImage: {
    width: "100%",
    height: "auto",
    maxWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      height: "100vh",
    },
  },
});

export default compose(withStyles(styles), withRouter)(DeleteAccMap);
